import type { JobTitleTypeI, JobTitleTypeFilterI } from 'types';
import { BaseApi } from './base-api';

class JobTitlesTypeApi extends BaseApi<JobTitleTypeI, JobTitleTypeFilterI> {}

const jobTitlesTypeApi = new JobTitlesTypeApi('/job-title-types');

export default jobTitlesTypeApi;
